import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config/apiClientConfig';

const memberSchema = z.object({
	dateOfBirth: z.string(),
	genderId: z.number(),
	relationshipTypeId: z.number(),
	priceWithVat: z.number(),
	priceWithoutVat: z.number(),
	mafDocumentUrl: z.string(),
	nationalityId: z.number(),
	memberId: z.string(),
});

const responseSchema = z.object({
	policyNumber: z.string(),
	startDate: z.string(),
	expiryDate: z.string(),
	issueDate: z.string(),
	insuranceCompanyId: z.number(),
	totalPolicyPremium: z.number(),
	policyWordingUrlEn: z.string(),
	policyWordingUrlAr: z.string(),
	policyCertificateUrl: z.string(),
	policyReceiptUrl: z.string(),
	policyInvoiceUrl: z.string(),
	planId: z.number(),
	members: z.array(memberSchema),
});

const getPolicyDetails = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/policy/:encryptedJourneyId',
		method: 'GET',
		responseSchema,
		requestParameters: { encryptedJourneyId: ['required', 'string'] },
	});

export default getPolicyDetails;

export type PolicyDetailsMember = z.infer<typeof memberSchema>;

export type GetPolicyDetailsAPIResponse = TypeOfAPIResponse<ReturnType<typeof getPolicyDetails>>;

export type GetPolicyDetailsError = TypeOfAPIError<ReturnType<typeof getPolicyDetails>>;
